module.exports = __webpack_public_path__ + "img/help_content2.bffe0eae.png";